import { createSelector } from 'reselect';
import { RootState } from '../index';

// Basic selectors
const selectColoringState = (state: RootState) => state.coloring;

// Individual selectors for coloring state properties
export const selectCurrentColor = createSelector(
  [selectColoringState],
  (coloringState) => coloringState.currentColor
);

export const selectHistory = createSelector(
  [selectColoringState],
  (coloringState) => coloringState.history
);

export const selectCurrentStep = createSelector(
  [selectColoringState],
  (coloringState) => coloringState.currentStep
);

// Memoized selector to get the current history step's data
export const selectCurrentHistoryStep = createSelector(
  [selectHistory, selectCurrentStep],
  (history, currentStep) => {
    // Ensure we have a valid history entry
    if (!history || history.length === 0 || currentStep < 0 || currentStep >= history.length) {
      return { coloredRegions: {} };
    }
    return history[currentStep];
  }
);

// Selector for the current colored regions
export const selectCurrentColoredRegions = createSelector(
  [selectCurrentHistoryStep],
  (currentHistoryStep) => currentHistoryStep.coloredRegions
);

// Selector for calculating the current color index based on the color scheme
export const makeSelectCurrentColorIndex = () => 
  createSelector(
    [selectCurrentColor, (_, colorScheme: string[] | undefined) => colorScheme],
    (currentColor, colorScheme) => {
      if (!colorScheme || !colorScheme.length) {
        return 1; // Default to 1 (first color)
      }
      return Math.max(colorScheme.findIndex(c => c === currentColor) || 0, 0) + 1;
    }
  ); 